import { Box, ModBox } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useEffect, useState } from 'react'
import { EmType } from '../..'
import { useLazyApiData, useStores } from '../../../../data/store'
import { isAccessible } from '../../../../utils'
import { StatusData } from '../../../Checker/Status/comps/StatusData'
import { StatusStateIcon } from '../../../Checker/Status/comps/StatusStateIcon'
import { StatusComp } from './StatusComp'
const CreationStatus = ({
  showSuccess,
  onGotoSettings,
  type,
  groupId,
  businessName,
  userId,
  isValidToProceed,
  resetNavigate,
  handleParentBack,
  isLinkToMAS,
  getCreationStatus,
}: any) => {
  const {
    createGroup,
    getCreateGroupData,
    createSubGroup,
    getSubGroupData,
    createEntity,
    getEntityData,
    resetCreateSingleEntitySelections,
    resetSelectionsDataOnSubmit,
    resetPagination,
    resetSelectedDate,
    setSideMenuRefresh,
    accessConfig,
    checkStatus,
  } = useStores((store) => ({
    createGroup: store.createEmsGroup,
    getCreateGroupData: store.onboarding.getCreateGroupData,
    createSubGroup: store.createSubGroup,
    getSubGroupData: store.onboarding.getSubGroupData,
    createEntity: store.createEntity,
    getEntityData: store.onboarding.getEntityData,
    resetCreateSingleEntitySelections: store.onboarding.resetCreateSingleEntitySelections,
    resetSelectionsDataOnSubmit: store.onboarding.resetSelectionsDataOnSubmit,
    resetPagination: store?.resetPagination,
    resetSelectedDate: store?.resetSelectedDate,
    setSideMenuRefresh: store.setSideMenuRefresh,
    accessConfig: store.user.getAccessConfig(['entity_management_service', 'ems_config']),
    checkStatus: store.checkApplicationStatus,
  }))
  const navigation = useNavigation()

  const [createEmsGroup, createGrpHandler] = useLazyApiData(createGroup)
  const [createEmsSubGroup, createSubGrpHandler] = useLazyApiData(createSubGroup)
  const [createSingleEntity, createSingleEntityHandler] = useLazyApiData(createEntity)
  const [lazyCheckStatus, checkStatusHandler] = useLazyApiData(checkStatus)

  const [isUserCreationPressed, setUserCreationPressed] = useState(false)
  const [isStatusSuccess, setIsStatusSuccess] = useState(false)
  const [isCreateSuccess, setIsCreateSuccess] = useState(false)
  const [applicationId, setApplicationId] = useState('')
  const [entityId, setEntityId] = useState('')
  const [failedErrorMsg, setFailedErrorMsg] = useState('')

  const [isLoading, setLoading] = useState(true)
  //TODO: MOVE all api calls to respective final step of creation flow
  useEffect(() => {
    if (type === EmType.createGroup) {
      const createGrpData = getCreateGroupData()
      createEmsGroup(createGrpData)
    } else if (type === EmType.createSubGroup) {
      const createSubGrpData = getSubGroupData()
      createEmsSubGroup(createSubGrpData)
    } else if (type === EmType.createSingleEntity) {
      const createEntityData = getEntityData(isLinkToMAS)
      createSingleEntity(createEntityData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (createGrpHandler.state === 'fulfilled' && !isCreateSuccess) {
      setIsCreateSuccess(true)
      setLoading(false)
      getCreationStatus && getCreationStatus('COMPLETED')
      setApplicationId(createGrpHandler?.data?.data?.applicationId)
    } else if (createGrpHandler.state === 'rejected') {
      setIsCreateSuccess(false)
      setLoading(false)
      getCreationStatus && getCreationStatus('FAILED')
    }
  }, [createGrpHandler, createGrpHandler.state, getCreationStatus, isCreateSuccess])

  useEffect(() => {
    if (createSubGrpHandler.state === 'fulfilled' && !isCreateSuccess) {
      setIsCreateSuccess(true)
      setLoading(false)
      getCreationStatus && getCreationStatus('COMPLETED')
      setApplicationId(createSubGrpHandler?.data?.data?.applicationId)
    } else if (createSubGrpHandler.state === 'rejected') {
      setIsCreateSuccess(false)
      setLoading(false)
      getCreationStatus && getCreationStatus('FAILED')
    }
  }, [createGrpHandler.state, createSubGrpHandler, getCreationStatus, isCreateSuccess])

  useEffect(() => {
    if (createSingleEntityHandler.state === 'fulfilled' && !isCreateSuccess) {
      setIsCreateSuccess(true)
      setLoading(false)
      setApplicationId(
        createSingleEntityHandler?.data?.data?.applicationId ?? createSingleEntityHandler?.data?.data?.fulfillmentId,
      )
      setIsStatusSuccess(true)
      getCreationStatus && getCreationStatus('COMPLETED')
    } else if (createSingleEntityHandler.state === 'rejected') {
      setIsCreateSuccess(false)
      setLoading(false)
      getCreationStatus && getCreationStatus('FAILED')
    }
    // resetCreateSingleEntitySelections()
  }, [
    createSingleEntityHandler?.data?.data?.fulfillmentId,
    createSingleEntityHandler.state,
    getCreationStatus,
    isCreateSuccess,
  ])

  useEffect(() => {
    if (isCreateSuccess && [EmType.createGroup, EmType.createSubGroup, EmType.createSingleEntity].includes(type)) {
      lazyCheckStatus(applicationId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreateSuccess])

  const handleProceedRetry = () => {
    if (createGrpHandler.state === 'rejected') {
      if (type === EmType.createGroup) {
        const createGrpData = getCreateGroupData()
        createEmsGroup(createGrpData)
      } else if (type === EmType.createSubGroup) {
        const createSubGrpData = getSubGroupData()
        createSubGroup(createSubGrpData)
      } else if (type === EmType.createSingleEntity) {
        const createEntityData = getEntityData()
        createSingleEntity(createEntityData, isLinkToMAS, applicationId)
      }
    } else {
      onGotoSettings && onGotoSettings()
    }
  }

  const typeTitle = `${
    type === EmType.createSingleEntity ? 'Entity' : type === EmType.createSubGroup ? 'SubGroup' : 'Group'
  }`

  const getStatusTitle = () => {
    if (!isLoading) {
      if (type === EmType.createSingleEntity) {
        return isStatusSuccess
          ? `Your ${typeTitle} creation application submitted and is pending for approval.\n You can check further status from your 'Application Queue'`
          : `Sorry, we couldn’t create the ${typeTitle}.\n${failedErrorMsg} \nPlease try again later.`
      } else {
        return isCreateSuccess
          ? `Your ${typeTitle} creation application submitted and is pending for approval.\n You can check further status from your 'Application Queue'`
          : `Sorry, we couldn’t create the ${typeTitle}.\n${failedErrorMsg} \nPlease try again later.`
      }
    }
  }

  const onUserCreationPressed = () => {
    setUserCreationPressed(true)
  }

  const navigateToMyAppQueue = () => {
    resetSelectedDate()
    resetPagination()
    if (type === EmType.myQueue) {
      handleParentBack && handleParentBack()
    }
    if (isAccessible(accessConfig, 'approve')) {
      navigation.navigate('checkerGlobalQueue')
      setSideMenuRefresh(true)
    } else {
      navigation.navigate('makerMyQueue')
      setSideMenuRefresh(true)
    }
  }

  const navigateToCreateGroup = () => {
    //TODO: Check
    if (type === EmType.myQueue || type === EmType.createGroup) {
      navigation.reset({
        index: 0,
        routes: [{ name: 'createEntityGroup' }],
      })
    } else if (type === EmType.createSubGroup) {
      navigation.reset({
        index: 0,
        routes: [{ name: 'createEntitySubGroup' }],
      })
    } else if (type === EmType.createSingleEntity) {
      resetCreateSingleEntitySelections()
      navigation.reset({
        index: 0,
        routes: [{ name: 'createSingleEntity' }],
      })
    }
    resetNavigate && resetNavigate()
    try {
      resetSelectionsDataOnSubmit()
    } catch (e) {
      console.log('e', e)
    }
  }

  const handleBack = () => {
    handleParentBack && handleParentBack()
  }

  const getStatus = (type: string) => {
    if (type === EmType.createGroup || type === EmType.createSubGroup) {
      return isCreateSuccess
    }
    if (type === EmType.createSingleEntity) {
      return isStatusSuccess
    }
  }

  const getCreationType = (type: string) => {
    const allTypes = {
      GROUP_ADD: 'Group',
      SUBGROUP_ADD: 'SubGroup',
      ENTITY_ADD: 'Entity',
    }
    return allTypes[type]
  }

  return (
    <>
      <ModBox
        show={[EmType.createGroup, EmType.createSubGroup, EmType.createSingleEntity].includes(type)}
        height={'100%'}
        justifyContent={'center'}>
        <Box direction="row" justifyContent={'center'}>
          <StatusStateIcon isApproved={isCreateSuccess} show={true} isProgress={isLoading} status={'completed'} />
          <StatusData
            isApproved={isCreateSuccess}
            title={
              isCreateSuccess
                ? `Application Sent for ${getCreationType(type)}`
                : 'An eror occured while submitting application'
            }
            subTitleKey={isCreateSuccess ? 'Application Id' : ' '}
            subTitleValue={isCreateSuccess ? applicationId : ' '}
            show={!isLoading}
          />
        </Box>
        <ModBox direction="row" justifyContent={'center'} show={isCreateSuccess}>
          <StatusStateIcon
            isApproved={checkStatusHandler.state === 'fulfilled'}
            show={true}
            isProgress={checkStatusHandler.state === 'pending'}
            status={'completed'}
          />
          <StatusData
            isApproved={checkStatusHandler.state === 'fulfilled'}
            title={
              isCreateSuccess
                ? `${getCreationType(type)} Created successfully `
                : `An eror occured while  creating ${getCreationType(type)}`
            }
            show={true}
          />
        </ModBox>
      </ModBox>
      <ModBox show={![EmType.createGroup, EmType.createSubGroup, EmType.createSingleEntity].includes(type)}>
        <StatusComp
          {...{
            isLoading,
            showSuccess,
            type,
            failedErrorMsg,
            isCreateSuccess,
            onBackPress: handleBack,
            isStatusSuccess,
            applicationId,
            businessName,
            isUserCreationPressed,
            navigateToMyAppQueue,
            navigateToCreateGroup,
          }}
        />
      </ModBox>
    </>
  )
}

export default CreationStatus
